<template>
    <div class="BookingCarsharingDetail">
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-if="carsharing"
                class="BookingCarsharingDetail-container"
            >
                <PageTitle class="BookingCarsharingDetail-title">
                    {{ $t('personal-account.carsharing.title') }}
                </PageTitle>
                <div
                    v-if="invoice"
                    class="BookingCarsharingDetail-invoice"
                >
                    {{ $t('personal-account.carsharing.invoice') }} # {{ invoice.number || invoice.reference }}
                </div>


                <div class="BookingCarsharingDetail-price">
                    {{ amount }}
                </div>
                <div class="BookingCarsharingDetail-tagContainer">
                    <Tag
                        type="success"
                        class="BookingCarsharingDetail-tag"
                    >
                        {{ duration }}
                    </Tag>
                    <Tag
                        type="success"
                        class="BookingCarsharingDetail-tag"
                    >
                        {{ distance }}
                    </Tag>
                </div>
                <RoundedButton
                    v-if="invoice"
                    :label="$t('personal-account.carsharing.download-invoice')"
                    type="white"
                    class="BookingCarsharingDetail-button"
                    @buttonClicked="goToInvoiceDetail"
                />
                <Block class="BookingCarsharingDetail-carsharingContainer">
                    <div class="BookingCarsharingDetail-pictureContainer">
                        <img
                            v-if="carsharing.car.picture"
                            class="BookingCarsharingDetail-carPicture"
                            :src="`/api/media/${carsharing.car.picture.slug}`"
                            alt="car"
                        >
                    </div>

                    <div class="BookingCarsharingDetail-carContainer">
                        <div class="BookingCarsharingDetail-make">
                            {{ carsharing.car.make }} {{ carsharing.car.model }}
                        </div>
                        <Tag type="default">
                            {{ carsharing.car.plateNumber }}
                        </Tag>
                    </div>
                    <div class="BookingCarsharingDetail-optionContainer">
                        <div
                            class="BookingCarsharingDetail-optionItem"
                        >
                            <span class="f2m-seat" /> <span>{{ carsharing.car.seats }}</span>
                        </div>
                        <div
                            class="BookingCarsharingDetail-optionItem"
                        >
                            <span class="f2m-transmission" /> <span>{{ $t(`personal-account.carsharing.transmission.${carsharing.car.transmission}`) }}</span>
                        </div>
                        <div
                            v-if="carsharing.car.fuel === 'electric'"
                            class="BookingCarsharingDetail-optionItem"
                        >
                            <span class="f2m-thunder" /> <span>{{ $t(`personal-account.carsharing.electric`) }}</span>
                        </div>
                        <div
                            v-if="carsharing.car.fuel === 'gasoline'"
                            class="BookingCarsharingDetail-optionItem"
                        >
                            <span class="f2m-gas-station" /> <span>{{ $t(`personal-account.carsharing.gasoline`) }}</span>
                        </div>
                        <div
                            v-if="carsharing?.car?.color"
                            class="BookingCarsharingDetail-optionItem"
                        >
                            <span class="f2m-color-palette" /> <span>{{ $t(`personal-account.carsharing.color.${carsharing.car.color}`) }}</span>
                        </div>
                    </div>
                </Block>
                <Block
                    :withoutPadding="true"
                    class="BookingCarsharingDetail-map"
                >
                    <Map
                        :latLng="mapLatLng"
                        :markers="markers"
                    />
                    <div
                        class="BookingCarsharingDetail-address"
                    >
                        <div>
                            {{ carsharing.from.spot.formatted[0] }}, {{ carsharing.from.spot.formatted[1] }}
                        </div>
                        <div v-if="carsharing.to">
                            <span
                                class="f2m-chevron-right BookingCarsharingDetail-chevron"
                            />
                        </div>
                        <div v-if="carsharing.to">
                            {{ carsharing.to.spot.formatted[0] }}, {{ carsharing.to.spot.formatted[1] }}
                        </div>
                    </div>
                </Block>
            </div>
        </Transition>
    </div>
</template>

<script>
import Component from 'vue-class-component'
import Vue from 'vue'
import PageTitle from '@/components/PageTitle.vue';
import Transition from "@/components/Transition.vue"
import Tag from "@/components/Tag.vue";
import {
    GET_INVOICES,
    GET_CARSHARINGS
} from "@/store/action-types";
import * as mutationTypes from "@/store/mutation-types";
import Money from "@free2move/money";
import {RoundedButton, Block} from "@free2move/vuejs-components";
import Map from "@/components/Map.vue";
@Component({
    components: {
        PageTitle,
        Transition,
        Tag,
        RoundedButton,
        Block,
        Map
    }
})
export default class BookingsCarsharingDetail extends Vue {
    data() {
        return {
            invoice: null,
            carsharing: null
        }
    }

    mounted() {
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_INVOICES, {
            callback: function (dataInvoice) {
                if (dataInvoice) {
                    this.invoice = dataInvoice[0];
                }
                this.$store.dispatch(GET_CARSHARINGS, {
                    callback: function (dataCarsharing) {
                        this.carsharing = dataCarsharing[0];
                        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                        window.scrollTo(0, 0);
                    }.bind(this),
                    data: {
                        conditions: {
                            _id: this.$route.params.id,
                        }
                    }
                });

            }.bind(this),
            data: {
                conditions: {
                    modelHolder: `carsharing+${this.$route.params.id}`,
                }
            }
        });
    }

    goToInvoiceDetail() {
        document.location.href= `/invoices/${this.invoice._id}?key=${this.invoice.key}`;
    }

    get amount() {
        return this.carsharing.detail?.grandTotal ? new Money({...this.carsharing.detail.grandTotal, language: this.$language}).format() : '';
    }

    get distance() {
        return this.carsharing.distance ? `${this.carsharing.distance.value} ${this.carsharing.distance.unit}` : '';
    }

    get duration() {
        return this.carsharing.duration ? `${this.carsharing.duration.value} ${this.carsharing.duration.unit}` : '';
    }

    get mapLatLng() {
        const fromLat = this.carsharing.from.spot.latitude
        const fromLng = this.carsharing.from.spot.longitude
        const toLat = this.carsharing.to?.spot.latitude
        const toLng = this.carsharing.to?.spot.longitude

        const maxLat = Math.max(fromLat, toLat || fromLat)
        const minLat = Math.min(fromLat, toLat || fromLat)

        const maxLng = Math.max(fromLng, toLng || fromLng)
        const minLng = Math.min(fromLng, toLng || fromLng)


        return [(maxLat + minLat) / 2, (maxLng + minLng) / 2]
    }

    get markers() {
        const markers = [{
            latLng: [this.carsharing.from.spot.latitude, this.carsharing.from.spot.longitude],
        }];

        if (this.carsharing.to?.spot) {
            markers.push({
                latLng: [this.carsharing.to.spot.latitude, this.carsharing.to.spot.longitude],
            })
        }


        return markers
    }
}
</script>

<style lang="scss" scoped>
.BookingCarsharingDetail {
    &-invoice {
        font-size: 22px;
        opacity: .7;
        color: $color-white;
    }

    &-price {
        font-weight: bold;
        font-size: 42px;
        line-height: 50px;
        color: #FFFFFF;
        margin-top: 48px;
    }

    &-tagContainer {
        display: flex;
        gap: 4px;
        margin-top: 4px;
        margin-bottom: 18px;
    }

    &-tag {
        font-size: 18px;
        line-height: 22px;
    }

    &-carPicture {
        margin-top: -128px;
        max-width: 356px;
        @media (max-width: $f2m-desktop-breakpoint) {
            margin-top: -100px;
            max-width: 250px;
        }
    }

    &-carContainer {
        display: flex;
        gap: 8px;
        align-items: center;
        margin-bottom: 16px;
    }

    &-carsharingContainer {
        margin-top: 128px;
        @media (max-width: $f2m-desktop-breakpoint) {
            margin-top: 100px;
        }
    }

    &-pictureContainer {
        width: 100%;
        text-align: center;
    }

    &-make {
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.3px;
    }

    &-optionContainer {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    &-map {
        margin-top: 24px;
    }

    &-address {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 28px;
        font-size: 14px;
        line-height: 24px;
        padding: 28px;
    }

    &-chevron {
        color: #467AFB;
        font-size: 24px;
    }

    &-optionItem {
        color: $color-f2m-purple-icon
    }
}
</style>
